<template>
  <div>
    <nav class="navbar navbar-light bg-light fixed-top">
      <!--ヘッダーにmax-width1920がいらない時はここを削除。対応する</div>も一緒に-->
      <div class="m-width1920">
        <div class="d-flex align-items-center">
          <!--ここまで↑-->
          <a class="navbar-brand" href="/">
            <img
              class="navbar-logo"
              src="../assets/img/logo/treasure_logo.png"
              alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
            />
          </a>
          <a class="nav-link" href="#"> TOP > お問い合わせ </a>
        </div>
      </div>
    </nav>
    <!--固定ヘッダー-->

    <!-- フォームセクション -->
    <div class="container mt-5 form__main">
      <div class="form-card card">
        <div class="card-body">
          <p class="lead form-text-center">お問い合わせ</p>
          <!-- お客様情報 placeholderにテキストを入れると未入力時に表示される-->
          <form>
            <div class="form-group">
              <label for="form-name" class="form-label">お名前 <span class="required-icon">必須</span></label>
              <input
                type="text"
                class="form-control"
                id="form-name"
                v-model="formData.name"
                placeholder=""
                required
                spellcheck="false"
              />
              <small v-if="errors.name" class="text-danger">{{
                errors.name
              }}</small>
            </div>

            <div class="form-group">
              <label for="form-name-kana" class="form-label"
                >お名前（カナ） <span class="required-icon">必須</span></label
              >
              <input
                type="text"
                class="form-control"
                id="form-name-kana"
                v-model="formData.nameKana"
                placeholder=""
                required
                spellcheck="false"
              />
              <small v-if="errors.nameKana" class="text-danger">{{
                errors.nameKana
              }}</small>
            </div>

            <div class="form-group">
              <label for="form-email" class="form-label">メールアドレス <span class="required-icon">必須</span></label>
              <input
                type="email"
                class="form-control"
                id="form-email"
                v-model="formData.email"
                placeholder=""
                required
                spellcheck="false"
              />
              <small v-if="errors.email" class="text-danger">{{
                errors.email
              }}</small>
            </div>

            <div class="form-group">
              <label for="form-message" class="form-label"
                >お問い合わせ内容 <span class="required-icon">必須</span></label
              >
              <textarea
                class="form-control"
                id="form-message"
                v-model="formData.message"
                placeholder="お問い合わせ内容を入力してください"
                rows="5"
                required
                spellcheck="false"
              ></textarea>
              <small v-if="errors.message" class="text-danger">{{
                errors.message
              }}</small>
            </div>
          </form>
          <div class="form-row form__btn_gap">
            <div class="col">
              <a
                href="/"
                class="form-btn-block form-btn-secondary btn btn-block"
                >TOPへ戻る</a
              >
            </div>
            <div class="col">
              <!-- 確認モーダルを開くボタン -->
              <button
                type="button"
                class="form-btn-block form-btn-primary btn btn-block"
                @click="submitForm"
              >
                入力内容の確認
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      formData: {
        name: "",
        nameKana: "",
        email: "",
        message: "",
      },
      errors: {},
    };
  },
  methods: {
 // バリデーションメソッド
    validateName(name) {
      // 漢字、ひらがな、カタカナ、アルファベットのみ許可
      const nameRegex = /^[\p{Script=Han}a-zA-Zぁ-んァ-ヶ々〆〤]+$/u;
      return nameRegex.test(name);
    },

    validateKana(kana) {
      // カタカナのみ許可
      const kanaRegex = /^[ァ-ヶー]+$/;
      return kanaRegex.test(kana);
    },

    validateEmail(email) {
      // 簡易的なメールアドレスの正規表現
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    
    submitForm() {
      this.errors = {};
      // お名前の必須チェックとバリデーションチェック
      if (!this.formData.name || this.formData.name.trim() === "") {
        this.errors.name = "お名前を入力してください。";
      } else if (!this.validateName(this.formData.name)) {
        this.errors.name = "お名前は漢字、ひらがな、カタカナ、半角アルファベットのみ入力可能です。";
      }

      // お名前（カナ）の必須チェックとバリデーションチェック
      if (!this.formData.nameKana || this.formData.nameKana.trim() === "") {
        this.errors.nameKana = "お名前（かな）を入力してください。";
      } else if (!this.validateKana(this.formData.nameKana)) {
        this.errors.nameKana = "お名前（カナ）はカタカナのみ入力してください。";
      }

      // その他の項目のチェック（例：メールアドレス、メッセージなど）
      if (!this.formData.email || this.formData.email.trim() === "") {
        this.errors.email = "メールアドレスを入力してください。";
      } else if (!this.validateEmail(this.formData.email)) {
        this.errors.email = "正しいメールアドレスを入力してください。";
      }
      if (!this.formData.message || this.formData.message.trim() === "") {
        this.errors.message = "お問い合わせ内容を入力してください。";
      }

      // エラーがある場合、モーダルを開かない
      if (Object.keys(this.errors).length > 0) {
        return;
      }

          // 送信前に sessionStorage に保存
      sessionStorage.setItem("name", this.formData.name);
      sessionStorage.setItem("nameKana", this.formData.nameKana);
      sessionStorage.setItem("email", this.formData.email);
      sessionStorage.setItem("message", this.formData.message);

      // 次ページに遷移
      this.$router.push({ name: 'InquiryConfirmation' });
    },
  },
};
</script>

<style scoped>
.close-button {
  position: sticky; /* 絶対位置を指定 */
  top: 0; /* モーダル内での上からの距離 */
  right: 0; /* モーダル内での右からの距離 */
  background: none;
  border: none;
  font-size: 40px;
  cursor: pointer;
  color: gray;
  font-weight: bold;
  text-align: right;
  width: 100%;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form__btn_gap {
  gap: 5vw;
  padding: 1vw 0 3vw 0;
}

.form-btn-block {
  padding: 10px;
  font-size: 16px;
  border-radius: 25px;
}
.btn-block {
  display: block;
  width: 100%;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.form__main {
  max-width: 700px;
}

.modal-title {
  width: 100%;
}

@media (max-width: 480px) {
  .form-btn-block {
    font-size: 10px;
  }
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  background-color: #000 !important; /* 背景色を黒 */
  -webkit-text-fill-color: #fff !important; /* テキスト色を白 */
  box-shadow: 0 0 0px 1000px #000 inset !important; /* 背景を完全に黒で塗りつぶす */
}

/* Firefox用 */
input:-moz-autofill,
textarea:-moz-autofill,
select:-moz-autofill {
  background-color: #000 !important; /* 背景色を黒 */
  color: #fff !important; /* テキスト色を白 */
}

/* :active時の色変更を防ぐ */
.form-btn-block:active {
  background-color: #fff; /* 背景色を維持 */
  color: #000; /* テキスト色を維持 */
}

/* :focus-visible時の色変更を防ぐ */
.form-btn-block:focus-visible {
  background-color: #fff; /* 背景色を維持 */
  color: #000; /* テキスト色を維持 */
}
.text-danger {
  margin-top: 0.25rem; /* 必要に応じて調整 */
  display: block; /* ブロック要素にすることで、横幅いっぱいに表示 */
}
.form-label {
  margin-top: 25px;
}
.form-control {
  margin-bottom: 0px;
}
.navbar {
  padding: 8px 10px;
}
.form__btn_gap {
  gap: 1vw;
  padding: 48px 0 0 0;
}

.required-icon {
  background-color: #ED4F64;
    font-size: 0.7rem;
    padding: 2px 9px 3px 7px;
    border-radius: 4px;
    margin-left: 10px;
    margin-bottom: 1px
}

.form-label {
  display: flex;
  align-items: center;
  text-align: center;
}
</style>
